module.exports = "/_next/static/images/Tharang2-36be0e4343ffd486b95865e822780e25.jpg";